<template>
  <div class="password-login-form">
    <div class="">
      <div class="left-login">
        <div class="rep-icon-login">
          <router-link
            to="/login"
            class="ms-0 ps-0 login-highlight back-btn-pwd"
            >Back</router-link
          >
          <img src="../../assets/images/dashboard-rep.svg" alt="image-fluid" />
        </div>
        <div class="">
          <router-link to="/smart-login">
            <button class="qr-login-btn">
              <img
                src="../../assets/images/qr-icon.svg"
                alt="qr icon"
                class="me-2"
              />Login with QR
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <h4 class="login-title mb-0">Login to Continue</h4>

    <div class="auth-form pt-3 pb-3">
      <div class="email-change-wrap">
        <div class="">{{ repEmail }}</div>
        <div class="login-highlight" @click="goBack">Change</div>
      </div>

      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.stop.prevent="handleSubmit(handleLogin)">
          <label for="">Password<span class="required-label mt-2">*</span></label>
          <div class="login-password-container">
            <custom-input-text
              :rules="{ required: true }"
              :customMessages="`Please enter your password`"
              labelFor=""
              labelName="Password"
              placeholder="Please enter your password"
              :inputType="passwordType"
              formGroupClass="form-group mb-1"
              @emitChanges="resetErrorMsg"
              :isErrorFlagSet="passwordErrorFlag"
              :vmodel.sync="password"
            />
            <eye-button
              id="password"
              hideOnDefault="false"
              :value="password"
              class="login-toggle-eye-icon"
              type="text"
              @toggle="togglePasswordVisibility"
            ></eye-button>
            <div class="valid-error" v-if="passwordErrorFlag">
              {{ errorMsg }}
            </div>
          </div>
          <button
            class="submit-btn mt-3 next-btn"
            :disabled="loginLoader || lockoutTime > 0"
            type="submit"
          >
            <b-spinner v-if="loginLoader" small></b-spinner>
            Login
          </button>
        </form>
      </ValidationObserver>
      <lockout-timer
        v-if="lockoutTime > 0"
        :lockout-seconds="lockoutTime"
        @lockout-expired="handleLockoutExpired"
      />
    </div>

    <div class="left-login mb-0">
      <div></div>
      <router-link to="/forgot-password">
        <div class="login-highlight">Forgot Password?</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import helper from "@/resource/Helper";
import LockoutTimer from "../../components/ui/LockoutTimer";

export default {
  name: "PasswordLogin",
  components: {
    'lockout-timer': LockoutTimer
  },
  data() {
    return {
      password: "",
      loginLoader: false,
      otpLoader: false,
      passwordErrorFlag: false,
      errorMsg: "",
      passwordType: "password",
      isPasswordVisible: true,
      lockoutTime: 0 // Tracks lockout duration from backend
    };
  },
  computed: {
    repEmail() {
      return this.$store.getters.repEmail;
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
      this.passwordType = this.isPasswordVisible ? "text" : "password";
    },
    generateOTP() {
      let app = this;
      app.$store.commit("setAuthentication", false);
      app.otpLoader = true;
      axios
        .post(app.$endpoint.API_V4_GENERATE_OTP, {
          email: this.$store.getters.repEmail,
          device_id: this.$store.getters.deviceId,
          type: `both`
        })
        .then(function (response) {
          if (response.data.status == "success") {
            app.$router.push('/login-otp')
            helper.infoMessage(
              app,
              response.data.status,
              response.data.message
            )
          }
          app.otpLoader = false;
          app.loginLoader = false;
        })
        .catch(function (error) {
          helper.infoMessage(
            app,
            error.response.data.status,
            error.response.data.message
          );
          app.otpLoader = false;
          app.loginLoader = false;
        });
    },
    async handleLogin() {
      let app = this;
      this.$store.commit("setAuthentication", false);
      app.loginLoader = true;
      app.passwordErrorFlag = false;
      app.errorMsg = "";
      try {
        const response = await axios.post(app.$endpoint.API_LOGIN_V4_URL, {
          email: this.$store.getters.repEmail,
          device_id: this.$store.getters.deviceId,
          password: app.password,
        });

        if (response.data.status === "success") {
          app.$router.push('/login-otp');
          helper.infoMessage(
            app,
            response.data.status,
            response.data.message
          );
        }
      } catch (error) {
        if (error.response?.status === 429 || error.response?.remaining_attempts	=== 0) { 
          const lockoutMatch = error.response.data.message?.match(/Try again after (\d+) seconds/);
          if (lockoutMatch && lockoutMatch[1]) {
            app.lockoutTime = parseInt(lockoutMatch[1], 10);
            app.resetErrorMsg();
          }
        } else if (error.response?.data?.status === "error") {
          app.passwordErrorFlag = true;
          app.errorMsg = error.response.data.message || "Login failed. Please try again.";
        }
      } finally {
        app.loginLoader = false;
      }
    },
    resetErrorMsg() {
      let app = this;
      app.passwordErrorFlag = false;
      app.errorMsg = '';
    },
    goBack() {
      this.$router.push('/email-login');
    },
    handleLockoutExpired() {
      this.lockoutTime = 0;
      this.passwordErrorFlag = false;
      this.errorMsg = '';
    }
  },
};
</script>

<style>
.multi-step-form {
  margin: auto;
}

.password-login-form .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.multi-step-form .step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.multi-step-form .step-indicator span {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multi-step-form .step-indicator span.active {
  background-color: #007bff;
  color: white;
}

.multi-step-form form {
  display: flex;
  flex-direction: column;
}

.multi-step-form label {
  margin-top: 10px;
}

.login-password-container {
  position: relative !important;
}

.login-toggle-eye-icon {
  position: absolute;
  top: 10px;
  right: 8px;
  cursor: pointer;
}

.login-password-container .is-valid {
  background-image: none !important;
}

.login-password-container .is-invalid {
  background-image: none !important;
}

.login-password-container .form-group {
  display: block !important;
}

.login-highlight {
  cursor: pointer;
}
</style>